import {getRequest, postRequest} from "../../../middlewares/api/actions";
import {
  getAllUpgradableDsdUrl,
  getCheckImportedFileXmlSdmxObjectsUrl,
  getCompareCodelistUrl,
  getCompareDsdsUrl,
  getCubeUrl,
  getDsdWithDataflowUrl,
  getGenerateFileReportDsdUrl,
  getGenerateReportDsdUrl,
  getImportFileXmlSdmxObjectsUrl,
  getUpgradeDsdUrl
} from "../../../constants/urls";
import moment from "moment";
import {getStringFromArtefactTriplet} from "../../../utils/sdmxJson";

export const UPGRADE_DSD_DSDS_READ = "UPGRADE_DSD_DSDS_READ";

export const UPGRADE_DSD_CUBES_READ = 'UPGRADE_DSD_CUBES_READ';
export const UPGRADE_DSD_CUBES_HIDE = 'UPGRADE_DSD_CUBES_HIDE';
export const UPGRADE_DSD_CUBES_SELECTED_CUBES_CHANGE = 'UPGRADE_DSD_CUBES_SELECTED_CUBES_CHANGE';

export const UPGRADE_DSD_UPGRADED_DSDS_SHOW = 'UPGRADE_DSD_UPGRADED_DSDS_SHOW';
export const UPGRADE_DSD_UPGRADED_DSDS_READ = 'UPGRADE_DSD_UPGRADED_DSDS_READ';
export const UPGRADE_DSD_UPGRADED_DSDS_HIDE = 'UPGRADE_DSD_UPGRADED_DSDS_HIDE';

export const UPGRADE_DSD_DSDS_COMPARE_SUBMIT = 'UPGRADE_DSD_DSDS_COMPARE_SUBMIT';
export const UPGRADE_DSD_DSDS_COMPARE_REPORT_HIDE = 'UPGRADE_DSD_DSDS_COMPARE_REPORT_HIDE';

export const UPGRADE_DSD_DSD_UPGRADE_SHOW = 'UPGRADE_DSD_DSD_UPGRADE_SHOW';
export const UPGRADE_DSD_DSD_UPGRADE_SUBMIT = 'UPGRADE_DSD_DSD_UPGRADE_SUBMIT';
export const UPGRADE_DSD_DSD_UPGRADE_HIDE = 'UPGRADE_DSD_DSD_UPGRADE_HIDE';

export const UPGRADE_DSD_DATAFLOWS_SHOW = 'UPGRADE_DSD_DATAFLOWS_SHOW';
export const UPGRADE_DSD_DATAFLOWS_HIDE = 'UPGRADE_DSD_DATAFLOWS_HIDE';

export const UPGRADE_DSD_CODELIST_COMPARE_REPORT_READ = 'UPGRADE_DSD_CODELIST_COMPARE_REPORT_READ';
export const UPGRADE_DSD_CODELIST_COMPARE_REPORT_HIDE = 'UPGRADE_DSD_CODELIST_COMPARE_REPORT_HIDE';

export const UPGRADE_DSD_IMPORT_DSD_SHOW = 'UPGRADE_DSD_IMPORT_DSD_SHOW';
export const UPGRADE_DSD_IMPORT_DSD_HIDE = 'UPGRADE_DSD_IMPORT_DSD_HIDE';

export const UPGRADE_DSD_IMPORT_DSD_FILE_SET = 'UPGRADE_DSD_IMPORT_DSD_FILE_SET';

export const UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_SUBMIT = 'UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_SUBMIT';
export const UPGRADE_DSD_DSDS_COMPARE_REPORT_DOWNLOAD = 'UPGRADE_DSD_DSDS_COMPARE_REPORT_DOWNLOAD';

export const UPGRADE_DSD_IMPORT_DSD_IMPORT_START = 'UPGRADE_DSD_IMPORT_DSD_IMPORT_START';
export const UPGRADE_DSD_IMPORT_DSD_FILE_UPLOAD = 'UPGRADE_DSD_IMPORT_DSD_FILE_UPLOAD';
export const UPGRADE_DSD_IMPORT_DSD_FILE_SUBMIT = 'UPGRADE_DSD_IMPORT_DSD_FILE_SUBMIT';
export const UPGRADE_DSD_IMPORT_DSD_REPORT_HIDE = 'UPGRADE_DSD_IMPORT_DSD_REPORT_HIDE';

export const readUpgradeDsdDsds = () => getRequest(
  UPGRADE_DSD_DSDS_READ,
  getDsdWithDataflowUrl()
);

export const readUpgradeDsdCubes = (sourceDsdTriplet, targetDsdTriplet) => ({
  ...getRequest(
    UPGRADE_DSD_CUBES_READ,
    getCubeUrl(null, getStringFromArtefactTriplet(sourceDsdTriplet))
  ),
  targetDsdTriplet
});

export const hideUpgradeDsdCubes = () => ({
  type: UPGRADE_DSD_CUBES_HIDE
});

export const changeUpgradeDsdCubesSelectedCubes = selectedCubes => ({
  type: UPGRADE_DSD_CUBES_SELECTED_CUBES_CHANGE,
  selectedCubes
});

export const showUpgradeDsdUpgradedDsds = dsdTriplet => ({
  type: UPGRADE_DSD_UPGRADED_DSDS_SHOW,
  dsdTriplet
});

export const hideUpgradeDsdUpgradedDsds = () => ({
  type: UPGRADE_DSD_UPGRADED_DSDS_HIDE
});

export const readUpgradeDsdUpgradedDsds = dsdTriplet => ({
  ...getRequest(
    UPGRADE_DSD_UPGRADED_DSDS_READ,
    getAllUpgradableDsdUrl(dsdTriplet)
  )
});

export const submitUpgradeDsdDsdsCompare = (sourceDsdTriplet, targetDsdTriplet, showModal) => ({
  ...postRequest(
    UPGRADE_DSD_DSDS_COMPARE_SUBMIT,
    getGenerateReportDsdUrl(sourceDsdTriplet, targetDsdTriplet, true),
    null,
    undefined,
    "application/json"
  ),
  showModal,
  targetDsdTriplet
});

export const hideUpgradeDsdDsdsCompareReport = () => ({
  type: UPGRADE_DSD_DSDS_COMPARE_REPORT_HIDE
});

export const showUpgradeDsdDsdUpgrade = cubes => ({
  type: UPGRADE_DSD_DSD_UPGRADE_SHOW,
  cubes
});

export const submitUpgradeDsdDsdUpgrade = (report, cubes) => postRequest(
  UPGRADE_DSD_DSD_UPGRADE_SUBMIT,
  getUpgradeDsdUrl(),
  {
    dsdReport: report,
    cubeList: cubes
  }
);

export const hideUpgradeDsdDsdUpgrade = success => ({
  type: UPGRADE_DSD_DSD_UPGRADE_HIDE,
  success
});

export const showUpgradeDsdDataflows = (dsdTriplet, dataflows) => ({
  type: UPGRADE_DSD_DATAFLOWS_SHOW,
  dsdTriplet,
  dataflows
});

export const hideUpgradeDsdDataflows = () => ({
  type: UPGRADE_DSD_DATAFLOWS_HIDE
});

export const readUpgradeDsdCodelistCompareReport = (sourceTriplet, targetTriplet, targetFile) => ({
  ...getRequest(
    UPGRADE_DSD_CODELIST_COMPARE_REPORT_READ,
    getCompareCodelistUrl(sourceTriplet, targetTriplet, null, targetFile)
  ),
  targetTriplet
});

export const hideUpgradeDsdCodelistCompareReport = () => ({
  type: UPGRADE_DSD_CODELIST_COMPARE_REPORT_HIDE
});

export const showUpgradeDsdImportDsd = () => ({
  type: UPGRADE_DSD_IMPORT_DSD_SHOW
});

export const hideUpgradeDsdImportDsd = () => ({
  type: UPGRADE_DSD_IMPORT_DSD_HIDE
});

export const setUpgradeDsdImportDsdFile = file => ({
  type: UPGRADE_DSD_IMPORT_DSD_FILE_SET,
  file
});

export const submitUpgradeDsdImportDsdDsdsCompare = (srcTriplet, targetFile, showModal) => {

  const customData = {
    sourceArtefact: {
      ID: srcTriplet.id,
      Agency: srcTriplet.agencyID,
      Version: srcTriplet.version,
      StreamType: 'Database'
    },
    targetArtefact: {
      StreamType: 'Xml'
    }
  };

  let fileFormData = new FormData();
  fileFormData.append('Files', targetFile);
  fileFormData.append('CustomData', JSON.stringify(customData));

  return {
    ...postRequest(
      UPGRADE_DSD_IMPORT_DSD_DSDS_COMPARE_SUBMIT,
      getCompareDsdsUrl(true),
      fileFormData
    ),
    showModal
  }
};

export const downloadUpgradeDsdDsdsCompareReport = (srcTriplet, targetTriplet, targetFile, lang) => {
  const currDate = moment().format('YYYY-MM-DD_HH-mm-ss');

  const fileSave = {
    name: `CompareDsds_${currDate}.txt`,
    type: "text/plain;charset=utf-8"
  };

  const customData = {
    sourceArtefact: {
      ID: srcTriplet.id,
      Agency: srcTriplet.agencyID,
      Version: srcTriplet.version,
      StreamType: 'Database'
    },
    targetArtefact: targetTriplet
      ? {
        ID: targetTriplet.id,
        Agency: targetTriplet.agencyID,
        Version: targetTriplet.version,
        StreamType: 'Database'
      }
      : {
        StreamType: 'Xml'
      }
  };

  let fileFormData = new FormData();
  if (targetFile !== null) {
    fileFormData.append('Files', targetFile);
  }
  fileFormData.append('CustomData', JSON.stringify(customData));

  return {
    ...postRequest(
      UPGRADE_DSD_DSDS_COMPARE_REPORT_DOWNLOAD,
      getGenerateFileReportDsdUrl(lang),
      fileFormData,
      undefined,
      undefined,
      true
    ),
    fileSave
  };
};

export const startUpgradeDsdImportDsdImport = () => ({
  type: UPGRADE_DSD_IMPORT_DSD_IMPORT_START
});

export const uploadUpgradeDsdImportDsdFile = file => {
  let fileFormData = new FormData();
  fileFormData.append('file', file);
  return postRequest(
    UPGRADE_DSD_IMPORT_DSD_FILE_UPLOAD,
    getCheckImportedFileXmlSdmxObjectsUrl(),
    fileFormData,
    t => ({
      success: t('scenes.utilities.importStructures.messages.fileUpload.success')
    })
  );
};

export const submitUpgradeDsdImportDsdFile = (structures, hash) => postRequest(
  UPGRADE_DSD_IMPORT_DSD_FILE_SUBMIT,
  getImportFileXmlSdmxObjectsUrl(),
  {
    importedItem: structures,
    hashImport: hash
  }
);

export const hideUpgradeDsdImportDsdReport = () => ({
  type: UPGRADE_DSD_IMPORT_DSD_REPORT_HIDE
});